import siteLogo from "../../../../assets/images/logo.png";
import Input from "../../../../components/form/Input";
import Button from "../../../../components/form/Button";
import useForm from "../../../../hooks/useForm";
import { formValidate } from "../../../../helpers/formValidate";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { login } from "../../../../redux/slice/authSlice";
import { useDispatch } from "react-redux";
import adminbg from "../../../../assets/images/adminbg.jpg";
import Image from "../../../../components/elements/Image";

const validation = {
  email: [
    {
      type: "email",
      required: true,
      message: "Enter valid Email",
    },
  ],
  password: [
    {
      type: "password",
      minLength: 8,
      required: true,
      message:
        "Password must be strong (min 8 characters, including uppercase, lowercase, number, and symbol)",
    },
  ],
};

const Login = () => {
  const { loginPending, loginData } = useSelector(
    (state) => state?.authProvider,
  );
  const dispatch = useDispatch();
  const location = useLocation();

  const { values, handleChange, handleSubmit, errors, setFieldsValue } =
    useForm({ validationRules: validation });

  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/admin/forgot-password", {
      state: "admin",
    });
  };

  const settings = useSelector((state) => state?.settings?.data);

  return (
    <div className="w-full min-h-screen bg-gradient-to-br from-denim to-mauve flex items-center justify-center py-6 px-6 relative z-0">
      <div className="absolute inset-0 z-[-1] opacity-50">
        <Image src={adminbg} alt={""} classes="object-cover" />
      </div>
      <div className="w-full max-w-md shadow-md relative z-10 rounded-xl bg-white py-6">
        <div className="flex min-h-full flex-1 flex-col justify-center px-2 py-4 lg:px-2 space-y-8">
          <div className="sm:mx-auto sm:w-full sm:max-w-sm space-y-8">
            <div className="w-full h-12 flex">
              <Image
                src={settings?.favicon?.url || siteLogo}
                alt={""}
                classes="object-contain"
              />
            </div>
            <div className="space-y-1 text-center">
              <h2 className="text-lg font-bold text-denim">Admin Login</h2>
              <h2 className="text-sm text-gray-500">
                Use your credential to access Admin panel
              </h2>
            </div>
          </div>

          <div className="mt-2 sm:mx-auto sm:w-full sm:max-w-sm">
            <form
              onSubmit={(event) =>
                handleSubmit(event, (val) => {
                  localStorage.setItem("lang", "en");
                  dispatch(
                    login({
                      ...val,
                      type: "admin",
                      redirect: "/admin/dashboard",
                      location,
                      navigate,
                    }),
                  );
                })
              }
            >
              <div className="relative mb-4">
                <Input
                  label={"Email"}
                  inputPlaceholder={"Enter your email"}
                  inputType={"text"}
                  value={values.email}
                  inputName={"email"}
                  inputClasses={""}
                  onChange={handleChange}
                  {...formValidate(errors, "email")}
                />
              </div>

              <div>
                <div className="relative mb-4">
                  <Input
                    label={"Password"}
                    inputPlaceholder={"Enter your password"}
                    inputType={"password"}
                    value={values.password}
                    inputName={"password"}
                    inputClasses={""}
                    onChange={handleChange}
                    {...formValidate(errors, "password")}
                  />
                </div>
              </div>

              <div className="relative">
                <Button
                  loading={loginPending}
                  buttonHasLink={false}
                  buttonType={"submit"}
                  buttonLabel={"Log in"}
                  buttonIconPosition={"left"}
                  buttonIcon={"fa-light fa-right-to-bracket"}
                  buttonClasses={"w-full"}
                />
              </div>
              {loginData?.status && loginData?.status !== 200 && (
                <div className="text-center text-primary text-xs mt-1">
                  {loginData?.message}
                </div>
              )}
              <div className="flex justify-center">
                <Button
                  buttonClasses={
                    "!justify-right !bg-transparent !text-slate-500 border-none"
                  }
                  buttonHasLink={false}
                  buttonType={"button"}
                  buttonLabel={"Forgot Password?"}
                  buttonFunction={handleClick}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
